/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_IntroInputs */

const en_register_onboarding_terms_intro = /** @type {(inputs: Register_Onboarding_Terms_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before submitting, binding consent is obtained: consent to data processing.`)
};

const de_register_onboarding_terms_intro = /** @type {(inputs: Register_Onboarding_Terms_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor dem Absenden wird eine verbindliche Einwilligung eingeholt: Einwilligung zur Datenverarbeitung.`)
};

/**
* | output |
* | --- |
* | "Before submitting, binding consent is obtained: consent to data processing." |
*
* @param {Register_Onboarding_Terms_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_terms_intro = /** @type {((inputs?: Register_Onboarding_Terms_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_intro(inputs)
	return en_register_onboarding_terms_intro(inputs)
});